import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import Products from '../views/Products.vue'
import After from '../views/After.vue'
import AppDownload from '../views/AppDownload.vue'
import Join from '../views/Join.vue'
import Support from '../views/Support.vue'
import News from '../views/News.vue'
import Download from '../views/Download.vue'
import contactus from '../views/contactus.vue'
import testpage from '../views/test.vue'
import productDetailVue from '../views/productDetail.vue'
import newsDetailVue from '../views/newsDetail.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'Home',
		component: Home
	},
	{
		path: '/about',
		name: 'About',
		component: About
	},
	{
		path: '/products',
		name: 'Products',
		component: Products
	},
	{
		path: '/after',
		name: 'After',
		component: After
	},
	{
		path: '/appDownload',
		name: 'AppDownload',
		component: AppDownload
	},
	{
		path: '/join',
		name: 'Join',
		component: Join
	},
	{
		path: '/support',
		name: 'Support',
		component: Support
	},
	{
		path: '/news',
		name: 'News',
		component: News
	},
	{
		path: '/download',
		name: 'Download',
		component: Download
	},
	{
		path: '/contactus',
		name: 'contact',
		component: contactus
	},
	{
		path: '/productDetail/:id',
		name: 'productDetail',
		component: productDetailVue
	},
	{
		path: '/newsDetail/:id',
		name: 'newsDetail',
		component: newsDetailVue
	}
]

const router = new VueRouter({
	mode: 'history',//要在服务器把所有路径重定向主页
	routes
});

const scrollPositions = {};

router.beforeEach((to, from, next) => {
	if (from.path) {
		scrollPositions[from.path] = {
			x: window.pageXOffset,
			y: window.pageYOffset
		};
	}
	next();
});

router.afterEach((to, from) => {
	const isNavigationBack = window.history.state && window.history.state.back;

	if (isNavigationBack && scrollPositions[to.path]) {
		const {
			x,
			y
		} = scrollPositions[to.path];
		window.scrollTo(x, y);
	} else {
		window.scrollTo(0, 0);
	}
});

export default router